import React, { useState } from "react";
import { Image as ImageIcon, Mail } from "lucide-react";
import PlatformBrandingCard from "./PlatformBrandingCard";
import PlatformEmailCard from "./PlatformEmailCard";

export default function BrandingPanel() {
  const [sub, setSub] = useState("product");
  return (
    <div data-testid="branding-panel">
      <div className="inline-flex rounded-lg bg-white/5 p-1 border border-white/10 mb-5">
        {[["product", "Logo & Name", ImageIcon], ["email", "Email", Mail]].map(([key, label, Icon]) => (
          <button
            key={key} data-testid={`branding-subtab-${key}`}
            onClick={() => setSub(key)}
            className={`inline-flex items-center gap-1.5 px-3.5 py-1.5 rounded-md text-[13px] font-medium transition-colors ${sub === key ? "bg-cyan-500/20 text-cyan-200" : "text-slate-400 hover:text-slate-200"}`}
          >
            <Icon className="h-3.5 w-3.5" /> {label}
          </button>
        ))}
      </div>
      {sub === "product" ? <PlatformBrandingCard /> : <PlatformEmailCard />}
    </div>
  );
}
